import { TableColumnDef } from '@/@account/types/entities';
import { ChipProps } from '@heroui/react';

export const ADMIN_ROLE = 'admin';
export const MEMBER_ROLE = 'member';
export const MAX_INVITE_FIELDS = 5;

export const TEAM_MANAGE_TABLE_COLUMNS: TableColumnDef[] = [
    { name: 'NAME', uid: 'name', sortable: true },
    { name: 'ROLE', uid: 'role', sortable: true },
    { name: 'STATUS', uid: 'status', sortable: true },
    { name: 'ACTIONS', uid: 'actions', sortable: false },
];

export const TEAM_MANAGE_TABLE_STATUS_OPTIONS = [
    { name: 'Active', uid: 'active' },
    { name: 'Pending', uid: 'pending' },
    { name: 'Inactive', uid: 'inactive' },
];

export const TEAM_MANAGE_TABLE_ROLES_OPTIONS = [
    {
        name: 'Admin',
        label: 'Admin',
        uid: ADMIN_ROLE,
        value: ADMIN_ROLE,
        description: 'team admin',
    },
    {
        name: 'member',
        label: 'Member',
        uid: MEMBER_ROLE,
        value: MEMBER_ROLE,
        description: 'team member',
    },
];

export enum APIEndpoints {
    USER_PROFILE = '/users/me',
    TEAM_MEMBERS = '/organization/members',
    INVITE_TEAM_MEMBERS = '/organization/invite',
    ORGANIZATION = '/organization',
    ORG_LIST = '/organization/list',
    FUND_DEPOSITS = '/transactions/funds',
    FUNDS_BALANCE = '/transactions/funds/balance',
    ADD_FUNDS = '/stripe/deposit',
    TRANSACTION_INVOICE = '/transactions/invoice',
    USERS_BY_EMAIL = '/users/by-email',
    USER_BUILDER_DISCOUNT = '/transactions/licenses/discount',
}

export const STATUS_COLOR: Record<string, ChipProps['color']> = {
    active: 'success',
    pending: 'warning',
};

export interface FontOption {
    key: string;
    label: string;
    googleFont?: string;
}

export const FONT_OPTIONS: FontOption[] = [
    // --- Normal ---
    { key: 'inter', label: 'Inter (Default)', googleFont: 'Inter' },
    { key: 'roboto', label: 'Roboto', googleFont: 'Roboto' },
    { key: 'open-sans', label: 'Open Sans', googleFont: 'Open+Sans' },
    { key: 'poppins', label: 'Poppins', googleFont: 'Poppins' },
    { key: 'nunito', label: 'Nunito', googleFont: 'Nunito' },
    { key: 'playfair', label: 'Playfair Display', googleFont: 'Playfair+Display' },
    { key: 'jetbrains-mono', label: 'JetBrains Mono', googleFont: 'JetBrains+Mono' },
    { key: 'system-ui', label: 'System UI' },
    // --- Silly ---
    { key: 'comic-sans', label: 'Comic Sans MS' },
    { key: 'papyrus', label: 'Papyrus' },
    { key: 'wingdings', label: 'Wingdings' },
    { key: 'press-start', label: 'Press Start 2P', googleFont: 'Press+Start+2P' },
    { key: 'creepster', label: 'Creepster', googleFont: 'Creepster' },
    { key: 'pacifico', label: 'Pacifico', googleFont: 'Pacifico' },
    { key: 'bungee-shade', label: 'Bungee Shade', googleFont: 'Bungee+Shade' },
];
